import React, { useState } from 'react';
// import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { Button,Box } from "@mui/material";
import { GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton } from "@mui/x-data-grid-premium";
import { isEmpty, objecttoFormData } from '../../services/Helpers/fonctions';
import Api from '../../services/Api';
import * as XLSX from 'xlsx';
import moment from 'moment/moment';
function ToolbarCMC({ apiRef,formFilters,filterModel,setIsLoading,isLoading }) {
   
    const [disabled, setDisabled] = useState(true);
    const [ datatoExport,setDatatoExport ] = useState([]);
    const api = new Api();
    // function getRandomInt(max) {
    //   return Math.floor(Math.random() * max);
    // }
    const onExportClick = async () => {
      try{
       setIsLoading(true);
      
       const sortModel = apiRef.current.getSortModel();
       const params = {
          ...formFilters,
          sort: JSON.stringify(sortModel)
        };
        if (filterModel.items.length > 0) {
          filterModel.items.forEach(filter => {
            if (filter.value && filter.value.toString().trim() !== '') {
              params[`filter[${filter.field}]`] = filter.value;
            }
          });
        } 
       // console.log(filterModel)
        const { status, data,errors } = await api.apiData("get","/paiement/cmc/exporter",{ params });
    
        if( data.length > 0 ){
         const workbook = XLSX.utils.book_new();
         const _data = data.map((dt,index) => {
          return {
            ordre: index + 1,
            reference: dt.reference,
            categorie: dt.nomCategorie,
            chassis: dt.chassis,
            montant: dt.montant,
            nomClient: dt.nomClient,
            prenomClient: dt.prenomClient,
            telephoneClient: dt.telephoneClient,
            emailClient: dt.emailClient ? dt.emailClient:'Non fournie' ,
            nomAgent: dt.nomAgent,
            prenomAgent: dt.prenomAgent,
            agence:dt.nom_agence,
            prefecture:dt.prefecture,
            commune: dt.commune,
            quartier:dt.quartier,
            status: dt.status,
            date: moment(dt.created_at).format('Do MMMM YYYY, H:mm:ss')

          }
         })
         const worksheet = XLSX.utils.json_to_sheet(_data);
          // Add worksheet to workbook
         XLSX.utils.book_append_sheet(workbook, worksheet, 'Stattistique');
         XLSX.writeFile(workbook, 'export_' + moment().format('dddd-Do-MMMM-YYYY')  + '.xlsx');
        }
      }
      catch(e){
        console.log("Erreur: ",e)
      }
      finally{
        setIsLoading(false); 
      }
    
    }
    
    return (
        <GridToolbarContainer>
          <GridToolbarFilterButton />  
          <GridToolbarDensitySelector />
          <Box sx={{ display: 'flex'}}>
            <Button
             variant="text" 
             onClick={onExportClick}
             disabled={isLoading}
            >
            Exporter
            </Button>
          {/* <Button onClick={() => setDisabled((state) => !state)}>
            {disabled ? "Enable" : "Disable"} export button
          </Button> */}
         </Box>
        </GridToolbarContainer>
      );
    };

export default ToolbarCMC